import type { SimplifySummary } from '../../midi/simplifyMidi'

export type MidiItem =
  | { id: string; status: 'parsing'; sourceName: string }
  | {
      id: string
      status: 'ready'
      sourceName: string
      bytes: Uint8Array
      summary: SimplifySummary
    }
  | { id: string; status: 'error'; sourceName: string; message: string }

export type MidiAction =
  | { type: 'add'; id: string; sourceName: string; insertAt?: number }
  | {
      type: 'parsed'
      id: string
      bytes: Uint8Array
      summary: SimplifySummary
    }
  | { type: 'error'; id: string; message: string }
  | { type: 'remove'; id: string }
  | { type: 'reorder'; from: number; to: number }

export function midiReducer(state: MidiItem[], action: MidiAction): MidiItem[] {
  switch (action.type) {
    case 'add': {
      const item: MidiItem = { id: action.id, status: 'parsing', sourceName: action.sourceName }
      if (typeof action.insertAt !== 'number') return [...state, item]
      const at = Math.max(0, Math.min(state.length, action.insertAt))
      const next = state.slice()
      next.splice(at, 0, item)
      return next
    }
    case 'parsed':
      return state.map((item) =>
        item.id === action.id
          ? {
              id: item.id,
              status: 'ready',
              sourceName: item.sourceName,
              bytes: action.bytes,
              summary: action.summary,
            }
          : item,
      )
    case 'error':
      return state.map((item) =>
        item.id === action.id
          ? {
              id: item.id,
              status: 'error',
              sourceName: item.sourceName,
              message: action.message,
            }
          : item,
      )
    case 'remove':
      return state.filter((item) => item.id !== action.id)
    case 'reorder': {
      if (action.from === action.to) return state
      if (action.from < 0 || action.from >= state.length) return state
      if (action.to < 0 || action.to >= state.length) return state
      const next = state.slice()
      const [moved] = next.splice(action.from, 1)
      next.splice(action.to, 0, moved)
      return next
    }
  }
}
